module.exports = __webpack_public_path__ + "static/media/ilab_logo.89caf75e.jpeg";